import { NotAvailableDialogComponent } from 'src/app/shared/components/not-available-dialog/not-available-dialog.component';
import { NotificationService } from 'src/app/shared/services/notification-service/notification.service';
import { UserManagementService } from 'src/app/services/property-matrixV2/services';
import { UserDto } from 'src/app/services/property-matrixV2/models';
import { GlobalMethods } from 'src/app/common/global-methods';
import { NavigationExtras, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { KeycloakService } from 'keycloak-angular';
import { Component, OnInit } from '@angular/core';
import { catchError, finalize, of } from 'rxjs';

@Component({
  selector: 'app-sell-your-property',
  templateUrl: './sell-your-property.component.html',
  styleUrls: ['./sell-your-property.component.scss', '../../../css/2-modules/_admin-portal.scss']
})
export class SellYourPropertyComponent implements OnInit {

  isloggedIn: boolean = false;
  loading: boolean = false;

  constructor(
    private _router: Router,
    private _notificationService: NotificationService,
    private _userManagementService: UserManagementService,
    private keycloakService: KeycloakService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.keycloakService.isLoggedIn().then((loggedIn: boolean) => {
      this.isloggedIn = loggedIn;
    });
    GlobalMethods.scrollToTop();
  }

  onProceed(route: string, sellerType: string, available: boolean): void {
    if (available) {
      if (this.isloggedIn) {
        this.checkIfLoggedInUserIsAgent(route, sellerType);
      } else {
        this._notificationService.showWarningMessage("Warning", "Please login to create listing.");
      }
    }
    else {
      this.openDialog();
    }
  }
  private checkIfLoggedInUserIsAgent(route: string, sellerType: string): void {
    this.loading = true;
    this._userManagementService.apiV1UserManagementGetCurrentUserLoggedInUserGet({})
      .pipe(
        catchError((err) =>
          of(this._notificationService.showErrorMessage("Error", "Could not load current logged in users to check the role."))
        ),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe((userDto: UserDto | void) => {
        if (userDto && userDto.userRoles) {
          const containsRoles = userDto.userRoles.some(r => (r.roleName === 'Senior Agent' && userDto.endorsed) || (r.roleName === 'Network Agent' && userDto.endorsed) || (r.roleName === 'Planner Portal Administrator' || r.roleName === "Principal Agent"));
          if (containsRoles == false) {
            if (userDto.endorsed == false) {
              this._notificationService.showWarningMessage("Warning", "You are not endorsed as an agent. Please contact your administrator.");
            }
            else {
              this._notificationService.showWarningMessage("Warning", "You are not an agent. Please contact your administrator.");
            }
          }
          else {
            const navigationExtras: NavigationExtras = {
              queryParams: {
                sellerType: sellerType
              }
            };
            this._router.navigate([route], navigationExtras);
          }
        } else if (userDto) {
          this._notificationService.showErrorMessage('Error', 'Could not load current logged in users to check the role.');
        }
      });
  }

  openDialog(): void {
    this.dialog.open(NotAvailableDialogComponent);
  }
}
